import React from 'react';
import vsbl from 'vsbl';
import cx from 'classnames';

class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      src: `${this.props.source}?q=80&fl=progressive`,
      visible: false,
      loaded: false,
      mounted: false,
    };

    this.image = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mounted: true,
      });
    });
    this.vs = vsbl(this.image.current)(() => {
      if (this.state.visible) return;

      this.setState({
        visible: true,
      });
    });

    this.vs.update(); // on page load
  }

  render() {
    const { src, visible, loaded, mounted } = this.state;

    return (
      <div className="x y image__block">
        <img
          ref={this.image}
          alt="SpaceAgency"
          src={mounted ? src : null}
          className={cx('x', {
            'is-visible': visible,
            'is-loaded': loaded,
          })}
          onLoad={() => {
            this.setState({
              loaded: true,
            });
          }}
        />
      </div>
    );
  }
}

export default Image;
